import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import getSymbolFromCurrency from "currency-symbol-map";

import { useAppDispatch, useAppSelector } from "store/index";
import { selectFilteredGeo } from "store/geoFilter/selectors";
import { handleSelectPaymentMethodConfigScope } from "store/payments/methods/slice";
import { unionPaymentConfigurationCurrencies } from "helpers/paymentConfigurationCurrencies";

const PaymentMethodConfigScopeTabs: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const config = useAppSelector((store) => store["payment-methods"].config);
  const geoList = useAppSelector(selectFilteredGeo);
  const baseCurrencies = useAppSelector((store) => store.settings.currencies);
  const payoutCurrencies = useAppSelector(
    (store) => store.settings.payoutCurrencies,
  );
  const currenciesList = useMemo(
    () => unionPaymentConfigurationCurrencies(baseCurrencies, payoutCurrencies),
    [baseCurrencies, payoutCurrencies],
  );

  const selectScope = (country: string, currency: string) => {
    if (config?.country === country && config?.currency === currency) {
      return;
    }
    dispatch(handleSelectPaymentMethodConfigScope({ country, currency }));
  };

  return (
    <div className="tabs-wrapper">
      <div className="game-modal-tabs bonus-currencies-tabs small">
        {geoList?.map((country) => (
          <div
            className={`tab-item ${config?.country === country ? "active" : ""}`}
            key={country}
            onClick={() =>
              selectScope(country, config?.currency ?? currenciesList[0] ?? "")
            }
          >
            <img
              src={`https://flagcdn.com/w40//${country.toLowerCase()}.png`}
              alt=""
            />
            {t(country)}
          </div>
        ))}
      </div>
      <div className="game-modal-tabs small">
        {currenciesList?.map((currency) => (
          <div
            className={`tab-item ${config?.currency === currency ? "active" : ""}`}
            key={currency}
            onClick={() =>
              selectScope(config?.country ?? geoList[0] ?? "", currency)
            }
          >
            <div className="currency-tab-item">
              <div className="currency">{getSymbolFromCurrency(currency)}</div>{" "}
              {currency}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodConfigScopeTabs;
